import axios from "axios";
export const BASE_URL = "https://aathraitribenimun.hamropalika.org";
export const baseURLAPI = "https://aathraitribenimun.hamropalika.org/api";
export default axios.create({
    baseURL: `${BASE_URL}/api/website/cache/`,
});
